// extracted by mini-css-extract-plugin
export var orderSummary = "_ni-0";
export var showMoreLessButton = "_ni-1";